import React from 'react'
import './Careers.css'

const Careers = () => {
  return (
    <div>
        <section id="careers">
            <h1 class="heading">Careers</h1>
            <p class="heading-text careers">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt totam voluptate veritatis optio. Vitae voluptas sunt adipisci iusto perferendis animi, repudiandae voluptatibus magnam. Voluptatibus beatae architecto rerum animi magnam! Tempore...</p>
            <a href="" class="read-more">Read More</a>
        </section>

        <footer>
            <div class="footer">
               <div class="last-message">
                   <h1 class="message">You are not late, you can still make the best desicion today.</h1>
                   <a href="" class="open-account">Open an Account</a>
               </div>
               <div class="footer2">
                   <ul>
                       <li><a href="index.html">Home</a></li>
                       <li><a href="">Pricing</a></li>
                       <li><a href="">Terms & conditions</a></li>
                       <li><a href="#careers">Careers</a></li>
                        <li><a href="">Contact us</a></li>
                   </ul>
               </div>
            </div>
        </footer>
    </div>
  )
}

export default Careers
